<template>
  <v-container fluid class="pa-0">
    <v-system-bar app color="bg_darkerish" height="24" v-if="offlineView">
      <span
        @click="$router.push({ name: 'playbook' })"
        class="caption font-weight-regular dw_green--text"
        style="cursor: pointer;">Pentesting Playbook</span>
    </v-system-bar>
    <navbar v-else />
    <v-progress-linear
      v-show="apiLoading"
      color="dw_green"
      height="8"
      striped
      indeterminate
      class="my-0" />
    <router-view />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import navbar from '@/components/appLayout/navbar.vue';

export default {
  name: 'defaultLayout',
  components: {
    navbar
  },
  provide: {
    system: {
      offline: process.env.VUE_APP_OFFLINE === 'TRUE'
    },
    permissions: {
      viewer: (groups) => groups.includes('VIEW_ONLY'),
      user: (groups) => groups.includes('USER_GROUP'),
      moderator: (groups) => groups.includes('MODERATOR_GROUP'),
      admin: (groups) => groups.includes('SUPER_GROUP')
    }
  },
  data() {
    return {
      offlineView: false
    };
  },
  computed: {
    ...mapGetters([
      'apiLoading'
    ])
  },
  methods: {
    ...mapActions([
      'fetchPlays',
      'fetchCAPECs',
      'fetchTechniques',
      'fetchControls',
      'fetchCWEs',
      'fetchFilterOptions',
      'fetchFormOptions'
    ])
  },
  created() {
    this.fetchPlays('?ordering=id');
    this.fetchCAPECs('?ordering=id');
    this.fetchTechniques('?revoked=false&deprecated=false&ordering=mitre_id&no_subs=true');
    this.fetchControls('?ordering=sort_id&type=SP800-53');
    this.fetchCWEs('?ordering=id');
    this.fetchFilterOptions();
    this.fetchFormOptions();
    if (process.env.VUE_APP_OFFLINE === 'TRUE') {
      this.offlineView = true;
    }
  }
};
</script>
